import { render, staticRenderFns } from "./FormResponseType9.vue?vue&type=template&id=0b0908c3&"
import script from "./FormResponseType9.vue?vue&type=script&lang=js&"
export * from "./FormResponseType9.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports